$(document).ready(function () {
  var hoverDelay;

  /**
   * Mark desktop hover targets that are actually expandable.
   * We will only apply hover-open behavior to these.
   *
   * Assumes: expandable items contain a submenu (your mega menu area)
   * like: .block_section-header--categories OR a drawer submenu container.
   */
  $(".header__inline-menu_hover").each(function () {
    var $el = $(this);
    var isExpandable =
      $el.find(".block_section-header--categories").length > 0 ||
      $el.find(".header__submenu, .mega-menu, .submenu, .dropdown, details").length > 0; // keep broad to match theme variants

    $el.toggleClass("is-expandable", !!isExpandable);
  });

  /**
   * Desktop hover behavior: ONLY for expandable items.
   * If it’s a leaf link, no "header-open" class, no hover-active changes.
   */
  $(".header__inline-menu_hover.is-expandable").hover(
    function () {
      clearTimeout(hoverDelay);
      hoverDelay = setTimeout(
        function () {
          $(".header__inline-menu_hover").removeClass("hover-active");
          $("body").stop().addClass("header-open", "slow");
          $(this).addClass("hover-active");
        }.bind(this),
        150
      );
    },
    function () {
      clearTimeout(hoverDelay);
      hoverDelay = setTimeout(
        function () {
          $("body").stop().removeClass("header-open", "slow");
          $(".header__inline-menu_hover").removeClass("hover-active");
        }.bind(this),
        150
      );
    }
  );

  /**
   * Category hover state — fix variable overwrite + ensure we bind to the anchors.
   */
  $(".block_section-header--cate-block").each(function () {
    var $block = $(this);
    var $links = $block.find(".block_section-header--inner-link li a");

    $links
      .on("mouseenter", function () {
        var $a = $(this);
        // If your .block_section-header--child and .block_section-header--image are siblings under li,
        // use closest li instead of find inside <a>.
        var $li = $a.closest("li");

        var data_link_menu = $li
          .find(".block_section-header--child")
          .attr("data-menu-product-title");
        var data_link_menu_image = $li
          .find(".block_section-header--image")
          .attr("data-menu-product-image");

        if (data_link_menu && data_link_menu_image && data_link_menu === data_link_menu_image) {
          $links.removeClass("block-header-inner-active");
          $a.addClass("block-header-inner-active");
        }
      })
      .on("mouseleave", function () {
        // optional
      });

    $links.first().addClass("block-header-inner-active");
  });

  /**
   * Your “remove plus after index >= 2” logic stays.
   */
  $(".header__inline-menu_hover").each(function (index) {
    var $menu = $(this);
    if (index >= 2) {
      $menu.find(".plus").remove();
    }
  });

  /**
   * Accordion behavior only for first 2 menus (unchanged)
   */
  $(".header__inline-menu_hover:lt(2)").each(function () {
    var $menu = $(this);
    $menu.find(".otherlink .block_section-header--inner-link").hide();
    $menu
      .find(".otherlink .block_section-header--link-href:first")
      .addClass("active")
      .find(".block_section-header--inner-link")
      .show();

    $menu.find(".plus").on("click", function () {
      var accordion = $(this).closest(".block_section-header--link-href");
      $menu
        .find(".otherlink .block_section-header--link-href")
        .not(accordion)
        .removeClass("active")
        .find(".block_section-header--inner-link")
        .slideUp();

      accordion.toggleClass("active");
      accordion.find(".block_section-header--inner-link").slideToggle();
    });
  });

  /**
   * Shipping countdown (your logic, unchanged except minor cleanup)
   */
  const format1 = "DD-MM-YYYY";
  var date1 = new Date();
  var todayDate = moment(date1).format(format1);

  const selectors = { countdownWrapper: ".shippingCountdown", countdownText: ".shippingCountdownText" };
  var daydescriptor,
    offsetHour,
    offsetMinute,
    dayofweek = moment().isoWeekday(),
    hourofday = moment().hour(),
    minuteofhour = moment().minute(),
    timezone = moment.tz.guess();
  var dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  function isBeforeOffset(hour, minute, offsetHour, offsetMinute) {
    return hour < offsetHour || (hour === offsetHour && minute < offsetMinute);
  }

  offsetHour = 10;
  offsetMinute = 30;

  var isFestive =
    todayDate == $(".festive_date_1").data("festivedate") ||
    todayDate == $(".festive_date_2").data("festivedate") ||
    todayDate == $(".festive_date_3").data("festivedate") ||
    todayDate == $(".festive_date_4").data("festivedate") ||
    todayDate == $(".festive_date_5").data("festivedate") ||
    todayDate == $(".festive_date_6").data("festivedate") ||
    todayDate == $(".festive_date_7").data("festivedate");

  if (isFestive) {
    // set descriptor from matching festive-day data-shipday
    $(".festive-day").each(function (_, el) {
      var shipDay = el.dataset.shipday;
      var festiveDateAttr = el.dataset.festivedate;

      if (festiveDateAttr == todayDate && shipDay) {
        var parts = shipDay.split("-");
        var formattedDate = new Date(parts[2], parts[1] - 1, parts[0]);
        daydescriptor = dayNames[formattedDate.getDay()];
      }
    });
  } else {
    // normal weekday logic
    if (dayofweek >= 1 && dayofweek <= 5) {
      if (isBeforeOffset(hourofday, minuteofhour, offsetHour, offsetMinute)) {
        daydescriptor = "today";
      } else if (dayofweek === 5) {
        daydescriptor = "Monday";
      } else {
        daydescriptor = "tomorrow";
      }
    } else if (dayofweek === 6) {
      daydescriptor = "Monday";
    } else {
      daydescriptor = "tomorrow";
    }
  }

  // countdown render
  if (isBeforeOffset(hourofday, minuteofhour, offsetHour, offsetMinute)) {
    $(selectors.countdownText).countdown(
      moment().startOf("date").add(offsetHour, "h").add(offsetMinute, "m").toDate(),
      function (o) {
        if (o.offset.hours < 1)
          $(this).html(
            o.strftime(
              "Order within <strong>%-M min</strong> <strong>%S sec</strong> and it ships <strong>FREE " +
                daydescriptor +
                "</strong>."
            )
          );
        else
          $(this).html(
            o.strftime(
              "Order within <strong>%-H hr</strong> <strong>%-M min</strong> and it ships <strong>FREE " +
                daydescriptor +
                "</strong>."
            )
          );
      }
    );
  } else {
    $(selectors.countdownText).countdown(moment().endOf("date").toDate(), function (o) {
      if (o.offset.hours < 1)
        $(this).html(
          o.strftime(
            "Order within <strong>%-M min</strong> <strong>%S sec</strong> and it ships <strong>FREE " +
              daydescriptor +
              "</strong>."
          )
        );
      else
        $(this).html(
          o.strftime(
            "Order within <strong>%-H hr</strong> <strong>%-M min</strong> and it ships <strong>FREE " +
              daydescriptor +
              "</strong>."
          )
        );
    });
  }
});
